import { Body } from '@cointracker/styleguide/src/LoggedIn';
import { useTranslation } from 'react-i18next';
import { Integration } from 'src/types/graphql-types';

interface DefaultGenericInstructionsProps {
  integration: Integration;
}
export const DefaultGenericInstructions = ({
  integration,
}: DefaultGenericInstructionsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Body variant="body2" className="text-text-secondary">
        {t('add_wallet_modal.default_generic_instructions.title', {
          integrationName: integration.name,
        })}
      </Body>
      <ul className="list-decimal pl-24">
        <li className="mb-2 marker:text-text-secondary">
          <Body variant="body2" className="text-text-secondary">
            {t(
              'add_wallet_modal.default_generic_instructions.paste_public_address',
            )}
          </Body>
        </li>
        <li className="mb-2 marker:text-text-secondary">
          <Body variant="body2" className="text-text-secondary">
            {t(
              'add_wallet_modal.default_generic_instructions.click_add_integration',
              {
                integrationName: integration.name,
              },
            )}
          </Body>
        </li>
      </ul>
    </>
  );
};
